/**
 *
 * Button.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React, { Children } from 'react';
import PropTypes from 'prop-types';
import StyledButton from './StyledButton';
import Add from './Add';
import Sort from './Sort';

function Button(props) {
    const {
        handleRoute,
        children,
        className,
        textColor,
        backgroundColor,
        primary,
        typeAdd,
        typeSort,
        typeViewAs,
        typeCustom,
        loading,
        typeDownload,
        disabled
    } = props;

    return (
        <StyledButton
            className={`${className} d-flex flex-row align-items-center justify-content-center mb-2`}
            onClick={handleRoute}
            primary={primary}
            textColor={textColor}
            backgroundColor={backgroundColor}
            typeAdd={typeAdd}
            typeSort={typeSort}
            typeViewAs={typeViewAs}
            typeCustom={typeCustom}
            loading={loading}
            disabled={loading || disabled}
            typeDownload={typeDownload}
        >
            {typeAdd && <Add />}
            {loading ? "Loading ..." : Children.toArray(children)}
            {typeSort && <Sort />}
        </StyledButton>
    );
}

Button.propTypes = {
    handleRoute: PropTypes.func,
    children: PropTypes.node.isRequired,
    primary: PropTypes.bool,
    className: PropTypes.string,
    typeAdd: PropTypes.bool,
    typeSort: PropTypes.bool,
    typeViewAs: PropTypes.bool
};

Button.defaultProps = {
    handleRoute: null,
    primary: false,
    className: "",
    typeAdd: false,
    typeSort: false,
    typeViewAs: false
}

export default Button;